module.exports = "/assets/da1b0e237ffd8069d07293b4dacdb1b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/JD.png
// module id = 2630
// module chunks = 0